module.exports = __webpack_public_path__ + "img/payhere_banner_mobile.3d6ab4a9.png";